<template>
  <li class="login-sns-each naver">
    <a href="#" @click.prevent="loginNaver()">
      <span class="icon-sns icon-naver"></span>
      <span class="a11y-hidden">네이버로 로그인</span>
    </a>
    <div v-show="false" id="naverIdLogin"></div>
  </li>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-script-url */
import { loginProc } from '@/common/utils/login'
import constant from '@/common/resources/constant'
import { SNS_TYPE_NAVER, SOCIAL_LOGIN_SUCCESS_EVENT } from '@/common/resources/const'
import { getPromotionCodeFromUrl, loginRedirectUrl } from '@/common/utils/common'

export default {
  data () {
    return {
      signupResultCode: '302',
      loadingInterval: undefined,
      naverLogin: undefined,
      accessToken: ''
    }
  },
  methods: {
    login () {
      if (this.accessToken !== '') {
        loginProc({ userType: SNS_TYPE_NAVER, userId: this.accessToken, userPassword: '', saveId: '', autoLogin: '' }).then((data) => {
          this.$events.$emit(SOCIAL_LOGIN_SUCCESS_EVENT, data.needselectprofile)
        }).catch((error) => {
          if (error.response.status === 551 &&
            error.response.data.resultcode === this.signupResultCode) {
            window.location.href = loginRedirectUrl(error.response.data.resultoptional, getPromotionCodeFromUrl(location.href))
          }
        })
      }
    },
    loginNaver () {
      let loginElement = document.getElementById('naverIdLogin_loginButton')
      if (loginElement) {
        loginElement.setAttribute('href', 'javascript:;')

        /* eslint-disable no-constant-condition */
        if (/* @cc_on ! @ */ false) {
          // IE
          loginElement.fireEvent('onclick')
        } else {
          // Others
          let event = document.createEvent('MouseEvents')
          event.initEvent('click', false, true)
          loginElement.dispatchEvent(event)
        }
      }
    },
    postMessage (e) {
      let self = this
      if (e.origin === location.origin && e.data.eventMessage === 'naverLogin') {
        if (e.data.tokenReceiver) {
          const resObj = e.data.tokenReceiver
          const result = JSON.parse(resObj)
          if (result.success) {
            self.accessToken = decodeURIComponent(result.access_token)
            self.login()
          } else {
            alert('네이버 로그인에 실패 했습니다.')
          }
        }
      }
    }
  },
  created () {
    // var self = this
    // window.tokenReceiver = function (resObj) {
      // var result = JSON.parse(resObj)
      // if (result.success) {
      //   self.accessToken = decodeURIComponent(result.access_token)
      //   self.login()
      // } else {
      //   alert('네이버 로그인에 실패 했습니다.')
      // }
    // }
    // window.loginResponse = function (tokenObj) {
    //   self.naverLogin.getLoginStatus(function (status) {
    //     if (status) {
    //       self.login()
    //     }
    //   })
    // }

    let loadingInterval = setInterval(() => {
      if (window.naver) {
        // window.naver 로드 완료 되면 Interval 취소
        clearInterval(loadingInterval)

        // LoginWithNaverId 선언
        this.naverLogin = new naver.LoginWithNaverId(
          {
            clientId: 'IMRF4m29ielhnUTZYGHL', // 개발자센터에 등록한 ClientID
            // 개발자센터에 등록한 callback Url
            callbackUrl: constant.URL_PROTOCOL_WITH_DOMAIN + '/member/login_naver.html',
            isPopup: true, // 팝업을 통한 연동처리 여부
            callbackHandle: true, // callback 페이지 핸들링 여부
            loginButton: { color: 'green', type: 1, height: 60 } // 로그인 버튼의 타입을 지정
          }
        )

        // 설정정보를 초기화하고 연동 준비
        this.naverLogin.init()
      }
    }, 200)
  },
  mounted () {
    window.addEventListener('message', this.postMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.postMessage)
  }
}
</script>
